import React from 'react';
import { createForm } from 'rc-form';
import { List, InputItem, WhiteSpace, Toast, Button, WingBlank } from 'antd-mobile';

import { getAppId, checkIfLogin } from '@utils/global';
import { checkIfPhone } from '@utils/tools';
import { ajax } from '@utils/http';

import './BindPhonePage.less';

import { TopNav } from 'src/common/top-nav/TopNav';

// 定时器
let timer = null;

class BindPhonePage extends React.Component {
  state = {
    picCode: '',
    picCodeUrl: '/index.php?r=Login/GetIdentifyCode&i=' + parseInt(Math.random() * 10000000),
    identifyCode: '',
    verifying: false,
    time: 60,
    nextSteping: false,
    currentStep: 0,
    newPhone: '',
    binding: false,
  }
  constructor(props) {
    super(props)
    document.title = '绑定手机号';
  }
  /**
   * 处理input的值的更改
   */
  handleChange = (name, event) => {
    this.setState({
      [name]: event.target.value
    });
  }
  /**
   * 更换图形验证码
   */ 
  getPicCode = () => {
    this.setState({
      picCodeUrl: '/index.php?r=Login/GetIdentifyCode&i=' + parseInt(Math.random() * 10000000)
    })
  }
  /**
   * 获取验证码
   */
  getIdentifyCode = () => {
    if (this.state.verifying) {
      return;
    }
    if (!this.state.picCode) {
      Toast.info('请输入图形验证码');
      return;
    }
    // 第二步才验证
    if (this.state.currentStep === 1 && !checkIfPhone(this.state.newPhone)) {
      Toast.info('请输入正确的手机号');
      return;
    }
    this.setState({
      verifying: true,
      time: 60
    });
    let url = '';
    let data = {
      app_id: getAppId(),
      pic_code: this.state.picCode,
    };
    if (this.state.currentStep === 0) {
      url = '/index.php?r=AppData/PhoneCode';
    } else if (this.state.currentStep === 1) {
      url = '/index.php?r=AppData/NewPhoneCode';
      data['phone'] = this.state.newPhone;
    }
    ajax({
      url: url,
      data: data,
      success: () => {
        timer = setInterval(() => {
          if (this.state.time === 0) {
            clearInterval(timer);
            this.setState({
              verifying: false,
              time: 60
            });
          }
          this.setState({
            time: --this.state.time
          })
        }, 1000);
      }
    })
  }
  /**
   * 下一步
   */
  handleNextStep = () => {
    if (this.state.nextSteping) {
      return;
    }
    if (!this.state.identifyCode) {
      Toast.info('请输入验证码');
      return;
    }
    this.setState({
      nextSteping: true
    });
    ajax({
      url: '/index.php?r=AppData/VerifyPhone',
      data: {
        app_id: getAppId(),
        code: this.state.identifyCode,
      },
      success: (res) => {
        // 还原下状态
        this.setState({
          nextSteping: false,
          currentStep: 1,
          verifying: false,
          time: 60,
          newPhone: '',
          picCode: '',
          identifyCode: '',
        });
        this.getPicCode(); // 更新图形验证码
      },
      error: () => {
        this.setState({
          nextSteping: false
        });
      }
    })
  }
  /**
   * 绑定手机
   */
  handleBindPhone = () => {
    if (this.state.binding) {
      return;
    }
    if (!checkIfPhone(this.state.newPhone)) {
      Toast.info('请输入正确的手机号');
      return;
    }
    if (!this.state.identifyCode) {
      Toast.info('请输入验证码');
      return;
    }
    this.setState({
      binding: true
    });
    ajax({
      url: '/index.php?r=AppData/VerifyNewPhone',
      data: {
        app_id: getAppId(),
        code: this.state.identifyCode,
        phone: this.state.newPhone,
      },
      success: (res) => {
        // 还原下状态
        this.setState({
          binding: false,
        });
        if (res.status !== 0) {
          Toast.info(res.data);
          return;
        }
        this.props.history.goBack();
        Toast.info('绑定成功');
      },
      error: () => {
        this.setState({
          binding: false
        });
      }
    })
  }
  render() {
    if (this.state.currentStep === 0) {
      return (
        <div id="bindPhonePage" className="page">
          <TopNav title="绑定手机号" />
          <WhiteSpace size="lg"/>
          <div className="row">
            <input className="pic-code-input" type="text" placeholder="图形验证码" value={this.state.picCode} onChange={this.handleChange.bind(this, 'picCode')}/>
            <img className="pic-code-url" src={this.state.picCodeUrl} onClick={this.getPicCode} />
          </div>
          <WhiteSpace />
          <div className="row">
            <input className="code-input" placeholder="请输入验证码" value={this.state.identifyCode} onChange={this.handleChange.bind(this, 'identifyCode')}/>
            <span className="get-code-btn" onClick={this.getIdentifyCode} >{(this.state.verifying && this.state.time !== 60) ? this.state.time + 's' : '获取验证码' }</span>
          </div>
          <WhiteSpace size="lg"/>
          <div className="row">
            <Button type="primary" style={{ fontSize: '16px', height: '38px', lineHeight: '38px' }} onClick={this.handleNextStep}>下一步</Button>
          </div>
        </div>
      )
    } else if (this.state.currentStep === 1) {
      return (
        <div id="bindPhonePage" className="page">
          <WhiteSpace size="lg"/>
          <div className="row">
            <div className="phone-label">绑定新手机号</div>
            <input className="phone-input" placeholder="请输入手机号" value={this.state.newPhone} onChange={this.handleChange.bind(this, 'newPhone')}/>
          </div>
          <WhiteSpace />
          <div className="row">
            <input className="pic-code-input" type="text" placeholder="图形验证码" value={this.state.picCode} onChange={this.handleChange.bind(this, 'picCode')}/>
            <img className="pic-code-url" src={this.state.picCodeUrl} onClick={this.getPicCode} />
          </div>
          <WhiteSpace />
          <div className="row">
            <input className="code-input" placeholder="请输入验证码" value={this.state.identifyCode} onChange={this.handleChange.bind(this, 'identifyCode')}/>
            <span className="get-code-btn" onClick={this.getIdentifyCode} >{(this.state.verifying && this.state.time !== 60) ? this.state.time + 's' : '获取验证码' }</span>
          </div>
          <WhiteSpace size="lg"/>
          <div className="row">
            <Button type="primary" style={{ fontSize: '16px', height: '38px', lineHeight: '38px' }} onClick={this.handleBindPhone}>确认绑定</Button>
          </div>
        </div>
      )
    }
  }
}
export default createForm()(BindPhonePage);


// WEBPACK FOOTER //
// ./src/official-page/bind-phone-page/BindPhonePage.jsx